import { queryOptions } from '@tanstack/react-query'
import { getDueTasks, getEnquiryTasks, getEventTasks, getOpenKegTasks, getTask, getTaskAssignees, getTasks } from '../lib/api'
import type { RecipeKind, TaskArea, TaskView } from '../types'

const TASK_POLL_MS = 60 * 1000

type TaskTargetKind = 'event' | 'enquiry'

export const taskKeys = {
	all: ['tasks'] as const,
	lists: () => [...taskKeys.all, 'list'] as const,
	list: (view: TaskView) => [...taskKeys.lists(), view] as const,
	details: () => [...taskKeys.all, 'detail'] as const,
	detail: (id: number) => [...taskKeys.details(), id] as const,
	due: () => [...taskKeys.all, 'due'] as const,
	openKegs: () => [...taskKeys.all, 'open-kegs'] as const,
	target: (kind: TaskTargetKind, targetId: number) => [...taskKeys.all, kind, targetId] as const,
	assignees: (area: TaskArea, recipeKind: RecipeKind | null) => [...taskKeys.all, 'assignees', area, recipeKind] as const,
}

export const taskListQuery = (view: TaskView) =>
	queryOptions({ queryKey: taskKeys.list(view), queryFn: () => getTasks(view), refetchInterval: TASK_POLL_MS })

export const taskDetailQuery = (id: number) =>
	queryOptions({ queryKey: taskKeys.detail(id), queryFn: () => getTask(id), refetchInterval: TASK_POLL_MS })

export const dueTasksQuery = () => queryOptions({ queryKey: taskKeys.due(), queryFn: getDueTasks, refetchInterval: TASK_POLL_MS })

export const openKegTasksQuery = () =>
	queryOptions({ queryKey: taskKeys.openKegs(), queryFn: getOpenKegTasks, refetchInterval: TASK_POLL_MS })

export const targetTasksQuery = (kind: TaskTargetKind, targetId: number) =>
	queryOptions({
		queryKey: taskKeys.target(kind, targetId),
		queryFn: () => (kind === 'event' ? getEventTasks(targetId) : getEnquiryTasks(targetId)),
		refetchInterval: TASK_POLL_MS,
	})

export const taskAssigneesQuery = (area: TaskArea, recipeKind: RecipeKind | null) =>
	queryOptions({
		queryKey: taskKeys.assignees(area, recipeKind),
		queryFn: () => getTaskAssignees(area, recipeKind ?? undefined),
		staleTime: 5 * 60 * 1000,
	})
